import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client/core'
import { setContext } from '@apollo/client/link/context'
// Create default client for Vue components using Pinia
import { useAuthStore } from '@/stores/auth'

// Create a factory function that accepts a getToken callback
export function createApolloClient(getToken?: () => string | null) {
  const httpLink = createHttpLink({
    uri: `${import.meta.env.VITE_BACKEND_HOST}${import.meta.env.VITE_GRAPHQL_PATH ?? '/graphql'}`,
  })

  const authLink = setContext((_, { headers }) => {
    const token = getToken?.() ?? null
    return {
      headers: { ...headers, authorization: token ? `Bearer ${token}` : '' },
    }
  })

  return new ApolloClient({
    link: authLink.concat(httpLink),
    cache: new InMemoryCache(),
  })
}

let authStore;
export const defaultClient = createApolloClient(() => {
  authStore ||= useAuthStore()
  return authStore.token
})

export default defaultClient
